<nav class="header-container" [ngClass]="{'shop-mode': isDarkText}">

  <div class="nav-links">
    <a routerLink="/shop" class="nav-item">CATÁLOGO</a>
  </div>

  <div class="logo-center">
    <span routerLink="/" class="logo-text">MOANANI</span>
  </div>

  <div class="nav-right">

    <div class="user-container" style="position: relative;">

      <div class="user-action" [class.login-pulse]="cart.loginPulse()" (click)="handleUserClick()" [title]="isLoggedIn ? 'Mi Cuenta' : 'Ingresar'">

        <svg *ngIf="!isLoggedIn" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>

        <div *ngIf="isLoggedIn" class="user-avatar">
          {{ userInitial }}
        </div>

      </div>

      <div *ngIf="showUserMenu" class="user-dropdown">

        <div *ngIf="isAdmin" class="dropdown-item-admin" routerLink="/admin/dashboard" (click)="showUserMenu = false" style="border-bottom: 1px solid #eee; font-weight: 600;">
          Dashboard Admin
        </div>

        <div class="dropdown-item-profile" routerLink="/profile" (click)="showUserMenu = false" style="font-weight: 500;">
          <i class="pi pi-user" style="margin-right: 8px;"></i> Mi Perfil
        </div>

        <div class="dropdown-item" (click)="logout()" style="color: #ef4444;">
          Cerrar Sesión
        </div>

      </div>

    </div>

    <div class="cart-btn" [class.login-pulse]="cart.loginPulse()">
      <a class="nav-icon cart-icon" (click)="cart.toggleCart()" style="cursor: pointer; display: flex; align-items: center; gap: 5px; position: relative;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="cart-icon-svg">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 5.513 7.5h12.974c.576 0 1.059.435 1.119 1.007ZM8.625 10.5a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm7.5 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
        </svg>
        <span class="cart-count" [class.has-items]="cart.totalItems() > 0">{{ cart.totalItems() }}</span>
      </a>
    </div>

  </div>
</nav>
